import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import SimpleSection from '../components/SimpleSection';
import ItemLayout from '../layouts/ItemLayout';
import ItemLayoutLoading from '../layouts/ItemLayoutLoading';
import GLIFOSViewer from '../viewer/GLIFOSViewer';
import { House } from 'react-bootstrap-icons';
import FG005back from '../images/backgrounds/GT-CIRMA-FG-005.jpg';
import { useParams } from 'react-router-dom';

const collectionInfo = {
	id: 'GT-CIRMA-FG-005',
	title: 'Archivo del estudio "Fotografía Japonesa"',
	subtitle: 'Fototeca Guatemala / Archivo del estudio "Fotografía Japonesa"',
};

export default function ISADgItem(props) {
	let { isadg } = useParams();
	const { apiService } = props;
	const [IsadgMetadata, setIsadgMetadata] = useState({
		isLoading: false,
		payload: {},
	});
	useEffect(() => {
		try {
			setIsadgMetadata({ isLoading: true, payload: {} });
			apiService.getItem({}, { isadg: isadg }, (_, rdata) => {
				//console.log(rdata);
				setIsadgMetadata({ isLoading: false, payload: rdata });
			});
		} catch (e) {
			//console.log(e);
			setIsadgMetadata({ isLoading: false, payload: {} });
		}
	}, [apiService, isadg]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	if (IsadgMetadata.isLoading) return <ItemLayoutLoading />;
	return (
		<ItemLayout
			title={collectionInfo.title}
			subtitle={collectionInfo.subtitle}
			backgroundImage={FG005back}
			subtitleIcon={<House />}
			IsadgData={IsadgMetadata.payload}
		>
			<SimpleSection className='c-welcome-cirma mb-4'>
				<Container>
					{IsadgMetadata.isLoading ? (
						'Loading...'
					) : IsadgMetadata.payload.hasOwnProperty('error') &&
					  IsadgMetadata.payload.error ? (
						(window.location = process.env.PUBLIC_URL + '/404')
					) : (
						<GLIFOSViewer
							itemInfo={IsadgMetadata.payload}
							apiService={apiService}
						/>
					)}
				</Container>
			</SimpleSection>
		</ItemLayout>
	);
}
